import React, { useEffect, useState, useRef } from "react";
import { Icon } from '@iconify/react'

import CardChart from "../BrandComparison/CardChart";

import "./History.scss";
import { auth, firestoredb } from "../../../config";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { Radar } from 'react-chartjs-2';
import 'chart.js/auto';
import { useReactToPrint } from 'react-to-print';
import GenerateReport from "../AnalyzeBrands/GenerateReport/GenerateReport";
import ProductReport from "../ProductReview/ProductReport";
import ReviewReport from "../Review/ReviewReport";


const History = () => {
  const [userId, setUserId] = useState(false);
  const [history, setHistory] = useState("");
  const [showAnalysis, setShowAnalysi] = useState(false)
  const [ourBrand, setOurBrand] = useState({});
  const [competitorsBrand, setCompetitorsBrand] = useState({});
  const [scoring, setScoring] = useState("");
  const [brandAnalysisHistory, setBrandAnalysisHistory] = useState("")
  const [brandAnalysis, setBrandAnalysis] = useState("")
  const [showBrandAnalysis, setShowBrandAnalysis] = useState("")
  const [productAnalysisHistory, setProductAnalysisHistory] = useState("")
  const [productAnalysis, setProductAnalysis] = useState("")
  const [showProductAnalysis, setShowProductAnalysis] = useState("")
  const [brandReviewsAnalysisHistory, setBrandReviewsAnalysisHistory] = useState("")
  const [brandReviewsAnalysis, setbrandReviewsAnalysis] = useState("")
  const [showbrandReviewsAnalysis, setShowbrandReviewsAnalysis] = useState("")
  const [historyCategory, setHistoryCategory] = useState("brandComparision")
  const user = auth.currentUser
  const reportRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => reportRef.current,
  });
  const dataOurBrand = {
    labels: ['Product', 'CX', 'Commercialization', 'Brand', 'Marketing'],
    datasets: [
      {
        label: `${ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation ? ourBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}`,
        data: [scoring && scoring.ourBrand && scoring.ourBrand.productAnalysis && scoring.ourBrand.productAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.cxAnalysis && scoring.ourBrand.cxAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.commercializationAnalysis && scoring.ourBrand.commercializationAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.brandAttribute && scoring.ourBrand.brandAttribute.score, scoring && scoring.ourBrand && scoring.ourBrand.marketingAnalysis && scoring.ourBrand.marketingAnalysis.score],
        fill: true,
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgb(54, 162, 235)',
        pointBackgroundColor: 'rgb(54, 162, 235)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(54, 162, 235)'
      },
      // {
      //     label: 'My Second Dataset',
      //     data: [28, 48, 40, 19, 96, 27, 100],
      // fill: true,
      // backgroundColor: 'rgba(54, 162, 235, 0.2)',
      // borderColor: 'rgb(54, 162, 235)',
      // pointBackgroundColor: 'rgb(54, 162, 235)',
      // pointBorderColor: '#fff',
      // pointHoverBackgroundColor: '#fff',
      // pointHoverBorderColor: 'rgb(54, 162, 235)'
      // }
    ]
  };

  const data = {
    labels: ['Product', 'CX', 'Commercialization', 'Brand', 'Marketing'],
    datasets: [
      {
        label: `${competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation ? competitorsBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}`,
        data: [scoring && scoring.competitorBrand && scoring.competitorBrand.productAnalysis && scoring.competitorBrand.productAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.cxAnalysis && scoring.competitorBrand.cxAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.commercializationAnalysis && scoring.competitorBrand.commercializationAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.brandAttribute && scoring.competitorBrand.brandAttribute.score, scoring && scoring.competitorBrand && scoring.competitorBrand.marketingAnalysis && scoring.competitorBrand.marketingAnalysis.score],
        fill: true,
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        borderColor: 'rgb(255, 99, 132)',
        pointBackgroundColor: 'rgb(255, 99, 132)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(255, 99, 132)'
      },
      // {
      //     label: 'My Second Dataset',
      //     data: [28, 48, 40, 19, 96, 27, 100],
      //     fill: true,
      //     backgroundColor: 'rgba(54, 162, 235, 0.2)',
      //     borderColor: 'rgb(54, 162, 235)',
      //     pointBackgroundColor: 'rgb(54, 162, 235)',
      //     pointBorderColor: '#fff',
      //     pointHoverBackgroundColor: '#fff',
      //     pointHoverBorderColor: 'rgb(54, 162, 235)'
      // }
    ]
  };

  const dataCombined = {
    labels: ['Product', 'CX', 'Commercialization', 'Brand', 'Marketing'],
    datasets: [
      {
        label: `${ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation ? ourBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}`,
        data: [scoring && scoring.ourBrand && scoring.ourBrand.productAnalysis && scoring.ourBrand.productAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.cxAnalysis && scoring.ourBrand.cxAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.commercializationAnalysis && scoring.ourBrand.commercializationAnalysis.score, scoring && scoring.ourBrand && scoring.ourBrand.brandAttribute && scoring.ourBrand.brandAttribute.score, scoring && scoring.ourBrand && scoring.ourBrand.marketingAnalysis && scoring.ourBrand.marketingAnalysis.score],
        fill: true,
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgb(54, 162, 235)',
        pointBackgroundColor: 'rgb(54, 162, 235)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(54, 162, 235)'
      },
      {
        label: `${competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation ? competitorsBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}`,
        data: [scoring && scoring.competitorBrand && scoring.competitorBrand.productAnalysis && scoring.competitorBrand.productAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.cxAnalysis && scoring.competitorBrand.cxAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.commercializationAnalysis && scoring.competitorBrand.commercializationAnalysis.score, scoring && scoring.competitorBrand && scoring.competitorBrand.brandAttribute && scoring.competitorBrand.brandAttribute.score, scoring && scoring.competitorBrand && scoring.competitorBrand.marketingAnalysis && scoring.competitorBrand.marketingAnalysis.score],
        fill: true,
        backgroundColor: 'rgba(255, 99, 132, 0.2)',
        borderColor: 'rgb(255, 99, 132)',
        pointBackgroundColor: 'rgb(255, 99, 132)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(255, 99, 132)'
      }
    ]
  };

  const options = {
    scale: {
      ticks: { beginAtZero: true }
    }
  };

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (auth.currentUser != null) {
        setUserId(auth.currentUser.uid);
      }
    });
  }, []);

  const getDataFromDb = async () => {
    if (user) {
      // console.log("Fetching Data from DB");
      const docRef = doc(firestoredb, "users", user.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        // console.log("Document data gs:", docSnap.data());
        if (docSnap.data().comparisionHistory) {
          //   setUserData({ ...docSnap.data().cvData, skills: docSnap.data().cvData.skills ? docSnap.data().cvData.skills : [], strengths: docSnap.data().cvData.strengths ? docSnap.data().cvData.strengths : [] })
          //   setIsFetched(true);
          //   setUserName(
          //     docSnap.data().firstName ? docSnap.data().firstName : "User"
          //   );
          // console.log("history", docSnap.data().cvDataHistory)
          setHistory(docSnap.data().comparisionHistory)
        }
        if (docSnap.data().brandAnalysis) {
          //   setUserData({ ...docSnap.data().cvData, skills: docSnap.data().cvData.skills ? docSnap.data().cvData.skills : [], strengths: docSnap.data().cvData.strengths ? docSnap.data().cvData.strengths : [] })
          //   setIsFetched(true);
          //   setUserName(
          //     docSnap.data().firstName ? docSnap.data().firstName : "User"
          //   );
          // console.log("history", docSnap.data().cvDataHistory)
          setBrandAnalysisHistory(docSnap.data().brandAnalysis)
        }
        if (docSnap.data().productAnalysis) {
          //   setUserData({ ...docSnap.data().cvData, skills: docSnap.data().cvData.skills ? docSnap.data().cvData.skills : [], strengths: docSnap.data().cvData.strengths ? docSnap.data().cvData.strengths : [] })
          //   setIsFetched(true);
          //   setUserName(
          //     docSnap.data().firstName ? docSnap.data().firstName : "User"
          //   );
          // console.log("history", docSnap.data().cvDataHistory)
          setProductAnalysisHistory(docSnap.data().productAnalysis)
        }
        if (docSnap.data().brandReviewsAnalysis) {
          //   setUserData({ ...docSnap.data().cvData, skills: docSnap.data().cvData.skills ? docSnap.data().cvData.skills : [], strengths: docSnap.data().cvData.strengths ? docSnap.data().cvData.strengths : [] })
          //   setIsFetched(true);
          //   setUserName(
          //     docSnap.data().firstName ? docSnap.data().firstName : "User"
          //   );
          // console.log("history", docSnap.data().cvDataHistory)
          setBrandReviewsAnalysisHistory(docSnap.data().brandReviewsAnalysis)
        }
      } else {
        // docSnap.data() will be undefined in this case
        // console.log("No such document!");
      }
    }
  }

  useEffect(() => {
    getDataFromDb();
  }, [userId])

  useEffect(() => {
    console.log("History", history);
    console.log("Brand Analysis", brandAnalysisHistory);
    console.log("Product Analysis", productAnalysisHistory);
    console.log("Brand Review Analysis", brandReviewsAnalysisHistory);
  }, [history, brandAnalysisHistory, productAnalysisHistory, brandReviewsAnalysisHistory])

  const getPageMarginsF = () => {
    return `@page :first { margin: ${"0px"} ${"0px"} ${"10px"} ${"0px"} !important; }`;
  };
  const getPageMargins = () => {
    return `@page { margin: ${"30px"} ${"30px"} ${"30px"} ${"30px"} !important; }`;
  };
  const getPageMarginst = () => {
    return `table { page-break-inside: avoid; }`;
  };

  return (
    <div className="HistoryReport-container customScroller">
      <div className="HistoryReport-inner-container">
        <h3>History</h3>
        <hr />
        {/* <div className="BrandHistory-container">
          <h3>Brand History</h3>
          <p className="pt-2">
            Proin varius aliquet lorem, at blandit magna ultricies et. Donec
            placerat arcu enim, laoreet sodales mauris fermentum quis.
            Suspendisse lectus augue, consectetur vel eleifend porta, consequat
            id diam. Aliquam semper congue odio a facilisis. Interdum et
            malesuada fames ac ante ipsum primis in faucibus. Suspendisse in sem
            et leo volutpat ornare. Etiam scelerisque vulputate volutpat. In hac
            habitasse platea dictumst. In id gravida odio. Phasellus varius
            metus sit amet pulvinar efficitur. Vestibulum rhoncus blandit nunc,
            non gravida felis imperdiet eu. Sed pellentesque, leo ac laoreet
            efficitur, nisl enim pharetra nulla, fringilla congue est turpis id
            augue.......
          </p>
          <div className="d-flex justify-content-end align-items-end mt-2">
            <button className="viewMoreBtn">View More</button>
          </div>
        </div> */}

        <div className="ComparisonHistory-container">
          <h3>Comparison History</h3>
          <select
            class="form-select form-select-sm"
            aria-label=".form-select-sm example"
            style={{ width: "170px" }}
            onChange={(e) => {
              setHistoryCategory(e.target.value);
              setShowAnalysi("")
              setShowBrandAnalysis("");
              setShowProductAnalysis("");
            }
            }

          >
            <option selected value="brandComparision" >Brand Comparasion</option>
            <option value="brandAnalysis">Brand Analysis</option>
            <option value="productAnalysis">Product Analysis</option>
            <option value="brandReviewsAnalysis">Brand Review Anaysis</option>
          </select>
        </div>



        <div>
          {
            historyCategory == "brandComparision" ?
              !showAnalysis ? history ?
                history.map((historyItem) => (
                  <>
                    <div className="ComparisonHistory-box-container mb-3 py-4">
                      <div className="w-75 time">
                        <h3>
                          {historyItem.ourBrand.mainAnalysis.brandInformation.brandName} <span>VS</span> {historyItem.competitorsBrand.mainAnalysis.brandInformation.brandName}
                        </h3>
                        <p>

                        </p>
                      </div>
                      <div className="w-25 time">
                        <div className="ComparisonHistory-timeDetail-box">
                          <p>2:30 PM</p>
                          <button className="viewMoreBtn" onClick={() => {
                            setOurBrand(historyItem.ourBrand);
                            setCompetitorsBrand(historyItem.competitorsBrand);
                            setScoring(historyItem.scoring);
                            setShowAnalysi(true);
                          }}>Details</button>

                        </div>
                      </div>
                    </div>

                  </>
                ))
                :
                "No History Found!"
                :
                <div className='ComparisonReport-container customScroller-transparent'>
                  <div className='ComparisonReport-inner-container'>
                    <h3 style={{ display: "flex", alignItems: "center" }}>Comparison Report
                      <button style={{ backgroundColor: "#93393C", color: "white", marginLeft: "20px", borderRadius: "5px", padding: "5px", fontSize: "16px" }} onClick={handlePrint}>Save PDF</button>
                    </h3>
                    <div className='ComparisonReport-leftRight-main' ref={reportRef}>
                      <style>{getPageMargins()}</style>
                      <style>{getPageMarginst()}</style>
                      <div className='ComparisonReport-left-main'>
                        <h5>{ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation ? ourBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}</h5>
                        <h6>{ourBrand.mainAnalysis && ourBrand.webUrl ? ourBrand.webUrl : "Website"}</h6>
                        <p>Following are the thorough analysis of {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation ? ourBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}</p>
                        <div className='ComparisonReport-rank-container'>
                          <div className='ComparisonReport-rankleft-box'>
                            <div>
                              <h6>Brand Health</h6>
                              <span><h4>{ourBrand.mainAnalysis && ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.companyAnalysis ? ourBrand.mainAnalysis.brandInformation.companyAnalysis.brandHealth : "Brand Health"}</h4></span>
                            </div>
                            <div>
                              <h6>Estimated Customers</h6>
                              <span><h4>{ourBrand.mainAnalysis && ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.companyAnalysis ? ourBrand.mainAnalysis.brandInformation.companyAnalysis.estimatedCustomer : "Estimated Customer"}</h4></span>
                            </div>
                          </div>
                          <div className='ComparisonReport-rankright-box'>
                            <div className='userCardDetails-ComparisonReport'>
                              <div className='userCardDetails-head-left'>
                                {/* <img src={nvidiaImg} alt='' /> */}
                                <h6>{ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation ? ourBrand.mainAnalysis.brandInformation.brandName : "Your Brand"}</h6>
                              </div>
                              <div className='userCardDetails-head-right'>
                                <p>GROWTH</p>
                                <span>{ourBrand.mainAnalysis && ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.companyAnalysis ? ourBrand.mainAnalysis.brandInformation.companyAnalysis.growthTrend
                                  : "Trend"}</span>
                              </div>
                            </div>
                            <div className='userCardDetails-ComparisonReport userCardDetails-ComparisonReport2'>
                              <div className='userCardDetails-visitors-left'>
                                <h5>Percentage</h5>
                                <p>{ourBrand.mainAnalysis && ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.companyAnalysis ? ourBrand.mainAnalysis.brandInformation.companyAnalysis.growthPercentageOfBrand : "%"}</p>
                              </div>
                              <div className='userCardDetails-graph-left'>
                                <CardChart />
                              </div>
                            </div>
                            {/* <img src={cardImg} alt='' /> */}
                          </div>
                        </div>

                        {/* <div className='ComparisonReport-performance-container '>
                                <h4>Facebook Analytics</h4>
                                <div className='performance-line-container performance-line-containerblue'>
                                    <div className='percentageLine' style={{ width: "92%" }}></div>
                                    <div className='percentageDot' style={{ left: "90%" }}>•</div>
                                </div>
                                <h5 className='performance-blue'>Performance 37%</h5>
                                <p>Aliquam gravida sapien leo, eget scelerisque magna convallis a. Phasellus dapibus ligula non.</p>
                            </div> */}

                        {/* <div className="ComparisonReport-performance-container">
                          <h4>Instagram Analytics</h4>
                          <div className="performance-line-container performance-line-containerpink">
                            <div
                              className="percentageLine"
                              style={{
                                width:
                                  ourBrand.instagramResults &&
                                  Math.round(ourBrand.instagramResults.averageScore) +
                                  "%",
                              }}
                            ></div>
                            <div
                              className="percentageDot"
                              style={{
                                left:
                                  ourBrand.instagramResults &&
                                  Math.round(ourBrand.instagramResults.averageScore) -
                                  2 +
                                  "%",
                              }}
                            >
                              •
                            </div>
                          </div>
                          <h5 className="performance-pink">
                            Performance{" "}
                            {ourBrand.instagramResults &&
                              Math.round(ourBrand.instagramResults.averageScore) + "%"}
                          </h5>
                          <p>
                            After analyzing different posts and their engagement ratio,
                            we have calculated this{" "}
                            <span style={{ color: "#CD486B" }}>Instagram</span> score.
                          </p>
                        </div> */}

                        {/* <div className='ComparisonReport-performance-container'>
                                <h4>X Analytics</h4>
                                <div className='performance-line-container performance-line-containerblack'>
                                    <div className='percentageLine'></div>

                                </div>
                                <h5 className='performance-black'>Performance 63%</h5>
                                <p>Aliquam gravida sapien leo, eget scelerisque magna convallis a. Phasellus dapibus ligula non.</p>
                            </div> */}

                        {/* <div className="ComparisonReport-performance-container">
                          <h4>Linkedin Analytics</h4>
                          <div className="performance-line-container performance-line-containerDarkBlue">
                            <div
                              className="percentageLine"
                              style={{
                                width:
                                  ourBrand.linkedinResults &&
                                  Math.round(ourBrand.linkedinResults.averageScore) +
                                  "%",
                              }}
                            ></div>
                            <div
                              className="percentageDot"
                              style={{
                                left:
                                  ourBrand.instagramResults &&
                                  Math.round(ourBrand.instagramResults.averageScore) -
                                  2 +
                                  "%",
                              }}
                            >
                              •
                            </div>
                          </div>
                          <h5 className="performance-DarkBlue">
                            Performance{" "}
                            {ourBrand.linkedinResults &&
                              Math.round(ourBrand.linkedinResults.averageScore) + "%"}
                          </h5>
                          <p>
                            After analyzing different posts and their engagement ratio,
                            we have calculated this{" "}
                            <span style={{ color: "#0A66C2" }}>Linkedin</span> score.
                          </p>
                        </div> */}

                        <h5>Revenue</h5>
                        <p>{ourBrand.mainAnalysis && ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.companyAnalysis ? ourBrand.mainAnalysis.brandInformation.companyAnalysis.estimatedRevenue : "%"}</p>

                        <h5>Recent Social Stats</h5>
                        <div className='dashboardMain-socialMediaStats-box'>
                          <h5>Instagram</h5>
                          <ul>
                            <li>
                              <span>Likes</span>
                              <span>{ourBrand.instagramResults && ourBrand.instagramResults.postData && ourBrand.instagramResults.postData[0].instaLikes}</span>
                            </li>
                            <li>
                              <span>Comments</span>
                              <span>{ourBrand.instagramResults && ourBrand.instagramResults.postData && ourBrand.instagramResults.postData[0].instaLikes}</span>
                            </li>
                            <li>
                              <span>Views</span>
                              <span>{ourBrand.instagramResults && ourBrand.instagramResults.postData && ourBrand.instagramResults.postData[0].instaPlayCount}</span>
                            </li>
                            <li>
                              <span>Share</span>
                              <span>{ourBrand.instagramResults && ourBrand.instagramResults.postData && ourBrand.instagramResults.postData[0].instaReshareCount}</span>
                            </li>
                          </ul>
                          <div className="keyProductFeatures liFlex" style={{ marginTop: "7px", color: "white" }}>
                            <h5>Social Analytics</h5>

                            <ul>
                              <h6>Audience Engagement Analysis</h6>
                              {ourBrand.mainAnalysis &&
                                ourBrand.mainAnalysis.brandInformation &&
                                ourBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                &&
                                ourBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                  .audienceEngagementAnalysis
                                ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                                  .audienceEngagementAnalysis.map(
                                    (feature) => (
                                      <li>
                                        <Icon
                                          icon="solar:map-arrow-right-bold-duotone"
                                          width="15"
                                          height="15"
                                        />
                                        {feature}
                                      </li>
                                    )
                                  )
                                : "Some Error Occured"}
                            </ul>

                            <ul style={{ marginTop: "7px" }}>
                              <h6>Social Content Analysis</h6>
                              {ourBrand.mainAnalysis &&
                                ourBrand.mainAnalysis.brandInformation &&
                                ourBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                &&
                                ourBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                  .contentAnalysis

                                ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                                  .contentAnalysis
                                  .map(
                                    (feature) => (
                                      <li>
                                        <Icon
                                          icon="solar:map-arrow-right-bold-duotone"
                                          width="15"
                                          height="15"
                                        />
                                        {feature}
                                      </li>
                                    )
                                  )
                                : "Some Error Occured"}
                            </ul>

                            <ul style={{ marginTop: "7px" }}>
                              <h6>Social Content Frequency Analysis</h6>
                              {ourBrand.mainAnalysis &&
                                ourBrand.mainAnalysis.brandInformation &&
                                ourBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                &&
                                ourBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                  .contentUploadingFrequencyAnalysis


                                ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                                  .contentUploadingFrequencyAnalysis

                                  .map(
                                    (feature) => (
                                      <li>
                                        <Icon
                                          icon="solar:map-arrow-right-bold-duotone"
                                          width="15"
                                          height="15"
                                        />
                                        {feature}
                                      </li>
                                    )
                                  )
                                : "Some Error Occured"}
                            </ul>

                            <ul style={{ marginTop: "7px" }}>
                              <h6>Response Rate Analysis</h6>
                              {ourBrand.mainAnalysis &&
                                ourBrand.mainAnalysis.brandInformation &&
                                ourBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                &&
                                ourBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                  .responseRate



                                ? ourBrand.mainAnalysis.brandInformation.socialAnalysis
                                  .responseRate


                                  .map(
                                    (feature) => (
                                      <li>
                                        <Icon
                                          icon="solar:map-arrow-right-bold-duotone"
                                          width="15"
                                          height="15"
                                        />
                                        {feature}
                                      </li>
                                    )
                                  )
                                : "Some Error Occured"}
                            </ul>

                          </div>
                        </div>
                        {/* <div className='py-3'>
                                <h6>Total Revenue: <span>51k</span></h6>
                                <SimplePieChart />
                            </div> */}

                        {/* <h5>Summary</h5>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent venenatis sem enim, non tristique magna rutrum vel. Praesent at ante vitae nibh malesuada bibendum eu id dolor. Integer scelerisque odio quis turpis laoreet, ac congue velit sodales. Phasellus pharetra ac leo eu gravida. </p> */}

                        <h5 className='pt-4 pb-3'>Product Feature Analysis</h5>
                        <div className="productAnalysisContent">
                          <div className="keyProductFeatures">
                            <h5>Key Product Features</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.keyProductFeatures ?
                                ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.keyProductFeatures.map((feature) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{feature}</li>
                                ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures">
                            <h5>Interesting Product Differentiations</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.interestingProductDifferntiators ?
                                ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.interestingProductDifferntiators.map((differntiators) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures">
                            <h5>Quotes about Product Features</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.length > 0 ?
                                ourBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.map((citedQuote) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                ))
                                :
                                "Not enough online presence found"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures scoring">
                            <h5>Scoring</h5>
                            <h6>{scoring && scoring.ourBrand && scoring.ourBrand.productAnalysis && scoring.ourBrand.productAnalysis.score + " out of 100"}</h6>
                            <div className='px-4'>
                              <div className='performance-line-container performance-line-containerDarkBlue'>
                                <div className='percentageLine' style={{ width: `${scoring && scoring.ourBrand && scoring.ourBrand.productAnalysis && scoring.ourBrand.productAnalysis.score}%` }}></div>
                              </div>
                            </div>
                            <p>{scoring && scoring.ourBrand && scoring.ourBrand.productAnalysis && scoring.ourBrand.productAnalysis.reason}</p>
                          </div>
                        </div>
                        <h5 className='pt-4'>Commercialization Analysis</h5>
                        <div className="productAnalysisContent">
                          <div className="keyProductFeatures">
                            <h5>Commercialization Strategies</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.keyCommercializationStrategies ?
                                ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.keyCommercializationStrategies.map((strategy) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures">
                            <h5>Interesting Commercialization Differentiations</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.interestingCommercializationDifferntiators ?
                                ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.interestingCommercializationDifferntiators.map((differntiators) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures">
                            <h5>Quotes about Commercialization Strategies</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes.length > 0 ?
                                ourBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes.map((citedQuote) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                ))
                                :
                                "Not enough online presence found"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures scoring">
                            <h5>Scoring</h5>
                            <h6>{scoring && scoring.ourBrand && scoring.ourBrand.commercializationAnalysis && scoring.ourBrand.commercializationAnalysis.score + " out of 100"}</h6>
                            <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.ourBrand && scoring.ourBrand.commercializationAnalysis && scoring.ourBrand.commercializationAnalysis.score}%` }}></div> </div> </div>
                            <p>{scoring && scoring.ourBrand && scoring.ourBrand.commercializationAnalysis && scoring.ourBrand.commercializationAnalysis.reason}</p>

                          </div>
                        </div>
                        <h5 className='pt-4'>Customer Experience (CX) Analysis</h5>
                        <div className="productAnalysisContent">
                          <div className="keyProductFeatures">
                            <h5>Key CX Strategies</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.keyCxStrategies ?
                                ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.keyCxStrategies.map((strategy) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures">
                            <h5>Interesting CX Differentiations</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.interestingCxDifferntiators ?
                                ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.interestingCxDifferntiators.map((differntiators) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures">
                            <h5>Quotes about Customer Experience</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes.length > 0 ?
                                ourBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes.map((citedQuote) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                ))
                                :
                                "Not enough online presence found"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures scoring">
                            <h5>Scoring</h5>
                            <h6>{scoring && scoring.ourBrand && scoring.ourBrand.cxAnalysis && scoring.ourBrand.cxAnalysis.score + " out of 100"}</h6>
                            <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.ourBrand && scoring.ourBrand.cxAnalysis && scoring.ourBrand.cxAnalysis.score}%` }}></div> </div> </div>
                            <p>{scoring && scoring.ourBrand && scoring.ourBrand.cxAnalysis && scoring.ourBrand.cxAnalysis.reason}</p>

                          </div>
                        </div>
                        <h5 className='pt-4'>Brand Attributes Analysis</h5>
                        <div className="productAnalysisContent">
                          <div className="keyProductFeatures">
                            <h5>Key Brand Attributes</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.keyBrandAttributes ?
                                ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.keyBrandAttributes.map((attribute) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{attribute}</li>
                                ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures">
                            <h5>Interesting Brand Differentiations</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.interestingBrandAttributesDifferntiators ?
                                ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.interestingBrandAttributesDifferntiators.map((differntiators) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures">
                            <h5>Quotes about Brand Attributes</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes.length > 0 ?
                                ourBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes.map((citedQuote) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="40" height="40" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                ))
                                :
                                "Not enough online presence found"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures scoring">
                            <h5>Scoring</h5>
                            <h6>{scoring && scoring.ourBrand && scoring.ourBrand.brandAttribute && scoring.ourBrand.brandAttribute.score + " out of 100"}</h6>
                            <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.ourBrand && scoring.ourBrand.brandAttribute && scoring.ourBrand.brandAttribute.score}%` }}></div> </div> </div>
                            <p>{scoring && scoring.ourBrand && scoring.ourBrand.brandAttribute && scoring.ourBrand.brandAttribute.reason}</p>

                          </div>
                        </div>
                        <h5 className='pt-4'>Marketing Analysis</h5>
                        <div className="productAnalysisContent">
                          <div className="keyProductFeatures">
                            <h5>Key Marketing Strategies</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.marketingAnalysis && ourBrand.mainAnalysis.brandInformation.marketingAnalysis.keyMarketingStrategies ?
                                ourBrand.mainAnalysis.brandInformation.marketingAnalysis.keyMarketingStrategies.map((strategy) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures">
                            <h5>Interesting Marketing Differentiations</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.marketingAnalysis && ourBrand.mainAnalysis.brandInformation.marketingAnalysis.interestingMarketingStrategiesDifferntiators ?
                                ourBrand.mainAnalysis.brandInformation.marketingAnalysis.interestingMarketingStrategiesDifferntiators.map((differntiators) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures">
                            <h5>Quotes about Marketing Strategies</h5>
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.marketingAnalysis && ourBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes && ourBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes.length > 0 ?
                                ourBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes.map((citedQuote) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                ))
                                :
                                "Not enough online presence found"}
                            </ul>
                          </div>
                          <div className="keyProductFeatures scoring">
                            <h5>Scoring</h5>
                            <h6>{scoring && scoring.ourBrand && scoring.ourBrand.marketingAnalysis && scoring.ourBrand.marketingAnalysis.score + " out of 100"}</h6>
                            <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.ourBrand && scoring.ourBrand.marketingAnalysis && scoring.ourBrand.marketingAnalysis.score}%` }}></div> </div> </div>
                            <p>{scoring && scoring.ourBrand && scoring.ourBrand.marketingAnalysis && scoring.ourBrand.marketingAnalysis.reason}</p>

                          </div>
                        </div>
                        <h5 className='pt-4'>Scoring Visualization</h5>

                        <div className="productAnalysisContent" style={{ backgroundColor: "#fff" }}>
                          <div className="keyProductFeatures">
                            <Radar data={dataOurBrand} options={options} />

                          </div>
                        </div>

                        <h5 className='pt-4'>Strengths</h5>
                        <div className="productAnalysisContent productAnalysisContent-Strengths">
                          <div className="keyProductFeatures keyProductFeatures-Strengths">
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.strengths ? ourBrand.mainAnalysis.brandInformation.strengths.map((strength) => (
                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strength}</li>
                              ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>

                        </div>
                        <h5 className='pt-4'>Weaknesses</h5>
                        <div className="productAnalysisContent productAnalysisContent-Weaknesses">
                          <div className="keyProductFeatures">
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.weaknesses ? ourBrand.mainAnalysis.brandInformation.weaknesses.map((weakness) => (
                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{weakness}</li>
                              ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>

                        </div>
                        <h5 className='pt-4'>Recommendation</h5>
                        <div className="productAnalysisContent productAnalysisContent-Recommendation">
                          <div className="keyProductFeatures">
                            <ul>
                              {ourBrand.mainAnalysis && ourBrand.mainAnalysis.brandInformation && ourBrand.mainAnalysis.brandInformation.recommendation ? ourBrand.mainAnalysis.brandInformation.recommendation.map((recommendation) => (
                                <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{recommendation}</li>
                              ))
                                :
                                "Some Error Occured"}
                            </ul>
                          </div>

                        </div>
                        {/* <h5 className='pt-4'>Digital Presence</h5>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent venenatis sem enim, non tristique magna rutrum vel.</p> */}
                      </div>

                      <div className="ComparisonReport-right-main">
                        <h5>
                          {competitorsBrand.mainAnalysis &&
                            competitorsBrand.mainAnalysis.brandInformation
                            ? competitorsBrand.mainAnalysis.brandInformation.brandName
                            : "Your Brand"}
                        </h5>
                        <h6>
                          {competitorsBrand.mainAnalysis && competitorsBrand.webUrl
                            ? competitorsBrand.webUrl
                            : "Website"}
                        </h6>
                        <p>
                          Following are the thorough analysis of{" "}
                          {competitorsBrand.mainAnalysis &&
                            competitorsBrand.mainAnalysis.brandInformation
                            ? competitorsBrand.mainAnalysis.brandInformation.brandName
                            : "Your Brand"}
                        </p>

                        <div className="ComparisonReport-rank-container">
                          <div className="ComparisonReport-rankleft-box">
                            <div>
                              <h6>Brand Health</h6>
                              <span>
                                <h4>
                                  {competitorsBrand.mainAnalysis &&
                                    competitorsBrand.mainAnalysis &&
                                    competitorsBrand.mainAnalysis.brandInformation &&
                                    competitorsBrand.mainAnalysis.brandInformation
                                      .companyAnalysis
                                    ? competitorsBrand.mainAnalysis.brandInformation
                                      .companyAnalysis.brandHealth
                                    : "Brand Health"}
                                </h4>
                              </span>
                            </div>
                            <div>
                              <h6>Estimated Customers</h6>
                              <span>
                                <h4>
                                  {competitorsBrand.mainAnalysis &&
                                    competitorsBrand.mainAnalysis &&
                                    competitorsBrand.mainAnalysis.brandInformation &&
                                    competitorsBrand.mainAnalysis.brandInformation
                                      .companyAnalysis
                                    ? competitorsBrand.mainAnalysis.brandInformation
                                      .companyAnalysis.estimatedCustomer
                                    : "Estimated Customer"}
                                </h4>
                              </span>
                            </div>
                          </div>
                          <div className="ComparisonReport-rankright-box">
                            <div className="userCardDetails-ComparisonReport">
                              <div className="userCardDetails-head-left">
                                {/* <img src={nvidiaImg} alt='' /> */}
                                <h6>
                                  {competitorsBrand.mainAnalysis &&
                                    competitorsBrand.mainAnalysis.brandInformation
                                    ? competitorsBrand.mainAnalysis.brandInformation
                                      .brandName
                                    : "Your Brand"}
                                </h6>
                              </div>
                              <div className="userCardDetails-head-right">
                                <p>GROWTH</p>
                                <span>
                                  {competitorsBrand.mainAnalysis &&
                                    competitorsBrand.mainAnalysis &&
                                    competitorsBrand.mainAnalysis.brandInformation &&
                                    competitorsBrand.mainAnalysis.brandInformation
                                      .companyAnalysis
                                    ? competitorsBrand.mainAnalysis.brandInformation
                                      .companyAnalysis.growthTrend
                                    : "Trend"}
                                </span>
                              </div>
                            </div>
                            <div className="userCardDetails-ComparisonReport userCardDetails-ComparisonReport2">
                              <div className="userCardDetails-visitors-left">
                                <h5>Percentage</h5>
                                <p>
                                  {competitorsBrand.mainAnalysis &&
                                    competitorsBrand.mainAnalysis &&
                                    competitorsBrand.mainAnalysis.brandInformation &&
                                    competitorsBrand.mainAnalysis.brandInformation
                                      .companyAnalysis
                                    ? competitorsBrand.mainAnalysis.brandInformation
                                      .companyAnalysis.growthPercentageOfBrand
                                    : "%"}
                                </p>
                              </div>
                              <div className="userCardDetails-graph-left">
                                <CardChart />
                              </div>
                            </div>
                            {/* <img src={cardImg} alt='' /> */}
                          </div>
                        </div>

                        {/* <div className='ComparisonReport-performance-container '>
                                <h4>Facebook Analytics</h4>
                                <div className='performance-line-container performance-line-containerblue'>
                                    <div className='percentageLine' style={{ width: "92%" }}></div>
                                    <div className='percentageDot' style={{ left: "90%" }}>•</div>
                                </div>
                                <h5 className='performance-blue'>Performance 37%</h5>
                                <p>Aliquam gravida sapien leo, eget scelerisque magna convallis a. Phasellus dapibus ligula non.</p>
                            </div> */}

                        {/* <div className="ComparisonReport-performance-container">
                          <h4>Instagram Analytics</h4>
                          <div className="performance-line-container performance-line-containerpink">
                            <div
                              className="percentageLine"
                              style={{
                                width:
                                  competitorsBrand.instagramResults &&
                                  Math.round(
                                    competitorsBrand.instagramResults.averageScore
                                  ) + "%",
                              }}
                            ></div>
                            <div
                              className="percentageDot"
                              style={{
                                left:
                                  competitorsBrand.instagramResults &&
                                  Math.round(
                                    competitorsBrand.instagramResults.averageScore
                                  ) -
                                  2 +
                                  "%",
                              }}
                            >
                              •
                            </div>
                          </div>
                          <h5 className="performance-pink">
                            Performance{" "}
                            {competitorsBrand.instagramResults &&
                              Math.round(
                                competitorsBrand.instagramResults.averageScore
                              ) + "%"}
                          </h5>
                          <p>
                            After analyzing different posts and their engagement ratio,
                            we have calculated this{" "}
                            <span style={{ color: "#CD486B" }}>Instagram</span> score.
                          </p>
                        </div> */}

                        {/* <div className='ComparisonReport-performance-container'>
                                <h4>X Analytics</h4>
                                <div className='performance-line-container performance-line-containerblack'>
                                    <div className='percentageLine'></div>

                                </div>
                                <h5 className='performance-black'>Performance 63%</h5>
                                <p>Aliquam gravida sapien leo, eget scelerisque magna convallis a. Phasellus dapibus ligula non.</p>
                            </div> */}

                        {/* <div className="ComparisonReport-performance-container">
                          <h4>Linkedin Analytics</h4>
                          <div className="performance-line-container performance-line-containerDarkBlue">
                            <div
                              className="percentageLine"
                              style={{
                                width:
                                  competitorsBrand.linkedinResults &&
                                  Math.round(
                                    competitorsBrand.linkedinResults.averageScore
                                  ) + "%",
                              }}
                            ></div>
                            <div
                              className="percentageDot"
                              style={{
                                left:
                                  competitorsBrand.instagramResults &&
                                  Math.round(
                                    competitorsBrand.instagramResults.averageScore
                                  ) -
                                  2 +
                                  "%",
                              }}
                            >
                              •
                            </div>
                          </div>
                          <h5 className="performance-DarkBlue">
                            Performance{" "}
                            {competitorsBrand.linkedinResults &&
                              Math.round(
                                competitorsBrand.linkedinResults.averageScore
                              ) + "%"}
                          </h5>
                          <p>
                            After analyzing different posts and their engagement ratio,
                            we have calculated this{" "}
                            <span style={{ color: "#0A66C2" }}>Linkedin</span> score.
                          </p>
                        </div> */}

                        <h5>Revenue</h5>
                        <p>{competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.companyAnalysis ? competitorsBrand.mainAnalysis.brandInformation.companyAnalysis.estimatedRevenue : "%"}</p>
                        <h5>Recent Social Stats</h5>
                        <div className='dashboardMain-socialMediaStats-box'>
                          <h5>Instagram</h5>
                          <ul>
                            <li>
                              <span>Likes</span>
                              <span>{competitorsBrand.instagramResults && competitorsBrand.instagramResults.postData && competitorsBrand.instagramResults.postData[0].instaLikes}</span>
                            </li>
                            <li>
                              <span>Comments</span>
                              <span>{competitorsBrand.instagramResults && competitorsBrand.instagramResults.postData && competitorsBrand.instagramResults.postData[0].instaLikes}</span>
                            </li>
                            <li>
                              <span>Views</span>
                              <span>{competitorsBrand.instagramResults && competitorsBrand.instagramResults.postData && competitorsBrand.instagramResults.postData[0].instaPlayCount}</span>
                            </li>
                            <li>
                              <span>Share</span>
                              <span>{competitorsBrand.instagramResults && competitorsBrand.instagramResults.postData && competitorsBrand.instagramResults.postData[0].instaReshareCount}</span>
                            </li>
                          </ul>
                          <div className="keyProductFeatures liFlex" style={{ marginTop: "7px", color: "white" }}>
                            <h5>Social Analytics</h5>

                            <ul>
                              <h6>Audience Engagement Analysis</h6>
                              {competitorsBrand.mainAnalysis &&
                                competitorsBrand.mainAnalysis.brandInformation &&
                                competitorsBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                &&
                                competitorsBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                  .audienceEngagementAnalysis
                                ? competitorsBrand.mainAnalysis.brandInformation.socialAnalysis
                                  .audienceEngagementAnalysis.map(
                                    (feature) => (
                                      <li>
                                        <Icon
                                          icon="solar:map-arrow-right-bold-duotone"
                                          width="15"
                                          height="15"
                                        />
                                        {feature}
                                      </li>
                                    )
                                  )
                                : "Some Error Occured"}
                            </ul>

                            <ul style={{ marginTop: "7px" }}>
                              <h6>Social Content Analysis</h6>
                              {competitorsBrand.mainAnalysis &&
                                competitorsBrand.mainAnalysis.brandInformation &&
                                competitorsBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                &&
                                competitorsBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                  .contentAnalysis

                                ? competitorsBrand.mainAnalysis.brandInformation.socialAnalysis
                                  .contentAnalysis
                                  .map(
                                    (feature) => (
                                      <li>
                                        <Icon
                                          icon="solar:map-arrow-right-bold-duotone"
                                          width="15"
                                          height="15"
                                        />
                                        {feature}
                                      </li>
                                    )
                                  )
                                : "Some Error Occured"}
                            </ul>

                            <ul style={{ marginTop: "7px" }}>
                              <h6>Social Content Frequency Analysis</h6>
                              {competitorsBrand.mainAnalysis &&
                                competitorsBrand.mainAnalysis.brandInformation &&
                                competitorsBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                &&
                                competitorsBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                  .contentUploadingFrequencyAnalysis


                                ? competitorsBrand.mainAnalysis.brandInformation.socialAnalysis
                                  .contentUploadingFrequencyAnalysis

                                  .map(
                                    (feature) => (
                                      <li>
                                        <Icon
                                          icon="solar:map-arrow-right-bold-duotone"
                                          width="15"
                                          height="15"
                                        />
                                        {feature}
                                      </li>
                                    )
                                  )
                                : "Some Error Occured"}
                            </ul>

                            <ul style={{ marginTop: "7px" }}>
                              <h6>Response Rate Analysis</h6>
                              {competitorsBrand.mainAnalysis &&
                                competitorsBrand.mainAnalysis.brandInformation &&
                                competitorsBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                &&
                                competitorsBrand.mainAnalysis.brandInformation
                                  .socialAnalysis
                                  .responseRate



                                ? competitorsBrand.mainAnalysis.brandInformation.socialAnalysis
                                  .responseRate


                                  .map(
                                    (feature) => (
                                      <li>
                                        <Icon
                                          icon="solar:map-arrow-right-bold-duotone"
                                          width="15"
                                          height="15"
                                        />
                                        {feature}
                                      </li>
                                    )
                                  )
                                : "Some Error Occured"}
                            </ul>

                          </div>
                        </div>
                        {/* <div className='py-3'>
                                <h6>Total Revenue: <span>51k</span></h6>
                                <SimplePieChart />
                            </div> */}

                        {/* <h5>Summary</h5>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent venenatis sem enim, non tristique magna rutrum vel. Praesent at ante vitae nibh malesuada bibendum eu id dolor. Integer scelerisque odio quis turpis laoreet, ac congue velit sodales. Phasellus pharetra ac leo eu gravida. </p> */}

                        <h5 className='pt-4 pb-3'>Product Feature Analysis</h5>
                        <p>
                          <div className="productAnalysisContent">
                            <div className="keyProductFeatures">
                              <h5>Key Product Features</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.keyProductFeatures ?
                                  competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.keyProductFeatures.map((feature) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />
                                      {feature}</li>
                                  ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures">
                              <h5>Interesting Product Differentiations</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.interestingProductDifferntiators ?
                                  competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.interestingProductDifferntiators.map((differntiators) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                  ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures">
                              <h5>Quotes about Product Features</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes && competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.length > 0 ?
                                  competitorsBrand.mainAnalysis.brandInformation.productFeaturesAnalysis.citedQuotes.map((citedQuote) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                  ))
                                  :
                                  "Not enough online presence found"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures scoring">
                              <h5>Scoring</h5>
                              <h6>{scoring && scoring.competitorBrand && scoring.competitorBrand.productAnalysis && scoring.competitorBrand.productAnalysis.score + " out of 100"}</h6>
                              <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.competitorBrand && scoring.competitorBrand.productAnalysis && scoring.competitorBrand.productAnalysis.score}%` }}></div> </div> </div>
                              <p>{scoring && scoring.competitorBrand && scoring.competitorBrand.productAnalysis && scoring.competitorBrand.productAnalysis.reason}</p>

                            </div>
                          </div>
                        </p>
                        <h5 className='pt-4'>Commercialization Analysis</h5>
                        <p>
                          <div className="productAnalysisContent">
                            <div className="keyProductFeatures">
                              <h5>Commercialization Strategies</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.keyCommercializationStrategies ?
                                  competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.keyCommercializationStrategies.map((strategy) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                  ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures">
                              <h5>Interesting Commercialization Differentiations</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.interestingCommercializationDifferntiators ?
                                  competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.interestingCommercializationDifferntiators.map((differntiators) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                  ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures">
                              <h5>Quotes about Commercialization Strategies</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes && competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes.length > 0 ?
                                  competitorsBrand.mainAnalysis.brandInformation.commercializationAnalysis.citedQuotes.map((citedQuote) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                  ))
                                  :
                                  "Not enough online presence found"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures scoring">
                              <h5>Scoring</h5>
                              <h6>{scoring && scoring.competitorBrand && scoring.competitorBrand.commercializationAnalysis && scoring.competitorBrand.commercializationAnalysis.score + " out of 100"}</h6>
                              <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.competitorBrand && scoring.competitorBrand.commercializationAnalysis && scoring.competitorBrand.commercializationAnalysis.score}%` }}></div> </div> </div>
                              <p>{scoring && scoring.competitorBrand && scoring.competitorBrand.commercializationAnalysis && scoring.competitorBrand.commercializationAnalysis.reason}</p>
                            </div>
                          </div>
                        </p>
                        <h5 className='pt-4'>Customer Experience (CX) Analysis</h5>
                        <p>
                          <div className="productAnalysisContent">
                            <div className="keyProductFeatures">
                              <h5>Key CX Strategies</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.keyCxStrategies ?
                                  competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.keyCxStrategies.map((strategy) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                  ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures">
                              <h5>Interesting CX Differentiations</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.interestingCxDifferntiators ?
                                  competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.interestingCxDifferntiators.map((differntiators) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                  ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures">
                              <h5>Quotes about Customer Experience</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes && competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes.length > 0 ?
                                  competitorsBrand.mainAnalysis.brandInformation.customerExperienceAnalysis.citedQuotes.map((citedQuote) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                  ))
                                  :
                                  "Not enough online presence found"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures scoring">
                              <h5>Scoring</h5>
                              <h6>{scoring && scoring.competitorBrand && scoring.competitorBrand.cxAnalysis && scoring.competitorBrand.cxAnalysis.score + " out of 100"}</h6>
                              <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine'></div> </div> </div>
                              <p>{scoring && scoring.competitorBrand && scoring.competitorBrand.cxAnalysis && scoring.competitorBrand.cxAnalysis.reason}</p>
                            </div>
                          </div>
                        </p>
                        <h5 className='pt-4'>Brand Attributes Analysis</h5>
                        <p>
                          <div className="productAnalysisContent">
                            <div className="keyProductFeatures">
                              <h5>Key Brand Attributes</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.keyBrandAttributes ?
                                  competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.keyBrandAttributes.map((attribute) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{attribute}</li>
                                  ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures">
                              <h5>Interesting Brand Differentiations</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.interestingBrandAttributesDifferntiators ?
                                  competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.interestingBrandAttributesDifferntiators.map((differntiators) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                  ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures">
                              <h5>Quotes about Brand Attributes</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes && competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes.length > 0 ?
                                  competitorsBrand.mainAnalysis.brandInformation.brandAttributesAnalysis.citedQuotes.map((citedQuote) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                  ))
                                  :
                                  "Not enough online presence found"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures scoring">
                              <h5>Scoring</h5>
                              <h6>{scoring && scoring.competitorBrand && scoring.competitorBrand.brandAttribute && scoring.competitorBrand.brandAttribute.score + " out of 100"}</h6>
                              <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.competitorBrand && scoring.competitorBrand.brandAttribute && scoring.competitorBrand.brandAttribute.score}%` }}></div> </div> </div>
                              <p>{scoring && scoring.competitorBrand && scoring.competitorBrand.brandAttribute && scoring.competitorBrand.brandAttribute.reason}</p>
                            </div>
                          </div>
                        </p>
                        <h5 className='pt-4'>Marketing Analysis</h5>
                        <p>
                          <div className="productAnalysisContent">
                            <div className="keyProductFeatures">
                              <h5>Key Marketing Strategies</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.keyMarketingStrategies ?
                                  competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.keyMarketingStrategies.map((strategy) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strategy}</li>
                                  ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures">
                              <h5>Interesting Marketing Differentiations</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.interestingMarketingStrategiesDifferntiators ?
                                  competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.interestingMarketingStrategiesDifferntiators.map((differntiators) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{differntiators}</li>
                                  ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures">
                              <h5>Quotes about Marketing Strategies</h5>
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes && competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes.length > 0 ?
                                  competitorsBrand.mainAnalysis.brandInformation.marketingAnalysis.citedQuotes.map((citedQuote) => (
                                    <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{citedQuote && citedQuote.quote ? citedQuote.quote : "Error Fecthing Quotes"}<em>{citedQuote && citedQuote.quote && citedQuote.source ? " - " : ""}{citedQuote && citedQuote.source ? citedQuote.source : "Error Fecthing Quotes"}</em></li>
                                  ))
                                  :
                                  "Not enough online presence found"}
                              </ul>
                            </div>
                            <div className="keyProductFeatures scoring">
                              <h5>Scoring</h5>
                              <h6>{scoring && scoring.competitorBrand && scoring.competitorBrand.marketingAnalysis && scoring.competitorBrand.marketingAnalysis.score + " out of 100"}</h6>
                              <div className='px-4'> <div className='performance-line-container performance-line-containerDarkBlue'> <div className='percentageLine' style={{ width: `${scoring && scoring.competitorBrand && scoring.competitorBrand.marketingAnalysis && scoring.competitorBrand.marketingAnalysis.score}%` }}></div> </div> </div>
                              <p>{scoring && scoring.competitorBrand && scoring.competitorBrand.marketingAnalysis && scoring.competitorBrand.marketingAnalysis.reason}</p>
                            </div>
                          </div>
                        </p>
                        <h5 className='pt-4'>Scoring Visualization</h5>

                        <div className="productAnalysisContent" style={{ backgroundColor: "#fff" }}>
                          <div className="keyProductFeatures">


                            <Radar data={data} options={options} />
                          </div>

                        </div>
                        <h5 className='pt-4'>Strengths</h5>
                        <p>
                          <div className="productAnalysisContent productAnalysisContent-Strengths">
                            <div className="keyProductFeatures keyProductFeatures-Strengths">
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.strengths ? competitorsBrand.mainAnalysis.brandInformation.strengths.map((strength) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{strength}</li>
                                ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>

                          </div>
                        </p>
                        <h5 className='pt-4'>Weaknesses</h5>
                        <p>
                          <div className="productAnalysisContent productAnalysisContent-Weaknesses">
                            <div className="keyProductFeatures keyProductFeatures-Weaknesses">
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.weaknesses ? competitorsBrand.mainAnalysis.brandInformation.weaknesses.map((weakness) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{weakness}</li>
                                ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>

                          </div>
                        </p>
                        <h5 className='pt-4'>Recommendation</h5>
                        <p>
                          <div className="productAnalysisContent productAnalysisContent-Recommendation">
                            <div className="keyProductFeatures keyProductFeatures-Recommendation">
                              <ul>
                                {competitorsBrand.mainAnalysis && competitorsBrand.mainAnalysis.brandInformation && competitorsBrand.mainAnalysis.brandInformation.recommendation ? competitorsBrand.mainAnalysis.brandInformation.recommendation.map((recommendation) => (
                                  <li><Icon icon="solar:map-arrow-right-bold-duotone" width="20" height="20" />{recommendation}</li>
                                ))
                                  :
                                  "Some Error Occured"}
                              </ul>
                            </div>

                          </div>
                        </p>
                        {/* <h5 className='pt-4'>Digital Presence</h5>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent venenatis sem enim, non tristique magna rutrum vel.</p> */}
                      </div>

                    </div>
                    <div style={{ width: "50%", margin: "0 auto" }}>
                      <h5 className='pt-4 text-center fw-bold fs-3'>Combined Scoring Visualization</h5>

                      <div className="productAnalysisContent" style={{ backgroundColor: "#fff" }}>
                        <div className="keyProductFeatures">
                          <Radar data={dataCombined} options={options} />

                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              :
              historyCategory == "brandAnalysis" ?
                !showBrandAnalysis ? brandAnalysisHistory ?
                  brandAnalysisHistory.map((historyItem) => (
                    <>
                      <div className="ComparisonHistory-box-container mb-3 py-4">
                        <div className="w-75 time">
                          <h3>
                            {historyItem.mainAnalysis.brandInformation.brandName}
                          </h3>
                          <p>

                          </p>
                        </div>
                        <div className="w-25 time">
                          <div className="ComparisonHistory-timeDetail-box">
                            <p>2:30 PM</p>
                            <button className="viewMoreBtn" onClick={() => {

                              setBrandAnalysis(historyItem)
                              setShowBrandAnalysis(true);
                            }}>Details</button>

                          </div>
                        </div>
                      </div>

                    </>
                  ))
                  :
                  "No History Found!"
                  :
                  <GenerateReport ourBrand={brandAnalysis} reportRef={reportRef} handlePrint={handlePrint}></GenerateReport>
                :

                historyCategory == "productAnalysis" ?
                  !showProductAnalysis ? productAnalysisHistory ?
                    productAnalysisHistory.map((historyItem) => (
                      <>
                        <div className="ComparisonHistory-box-container mb-3 py-4">
                          <div className="w-75 time">
                            <h3>
                              {historyItem.productName}
                            </h3>
                            <p>

                            </p>
                          </div>
                          <div className="w-25 time">
                            <div className="ComparisonHistory-timeDetail-box">
                              <p>2:30 PM</p>
                              <button className="viewMoreBtn" onClick={() => {

                                setProductAnalysis(historyItem)
                                setShowProductAnalysis(true);
                              }}>Details</button>

                            </div>
                          </div>
                        </div>

                      </>
                    ))
                    :
                    "No History Found!"
                    :
                    <ProductReport ourBrand={productAnalysis}></ProductReport>
                  :
                  historyCategory == "brandReviewsAnalysis" ?
                    !showbrandReviewsAnalysis ? brandReviewsAnalysisHistory ?
                      brandReviewsAnalysisHistory.map((historyItem) => (
                        <>
                          <div className="ComparisonHistory-box-container mb-3 py-4">
                            <div className="w-75 time">
                              <h3>
                                {historyItem.domainName}
                              </h3>
                              <p>

                              </p>
                            </div>
                            <div className="w-25 time">
                              <div className="ComparisonHistory-timeDetail-box">
                                <p>2:30 PM</p>
                                <button className="viewMoreBtn" onClick={() => {

                                  setbrandReviewsAnalysis(historyItem)
                                  setShowbrandReviewsAnalysis(true);
                                }}>Details</button>

                              </div>
                            </div>
                          </div>

                        </>
                      ))
                      :
                      "No History Found!"
                      :
                      <ReviewReport ourBrand={brandReviewsAnalysis}></ReviewReport>
                    :
                    ""
          }
          {/* {!showBrandAnalysis ? brandAnalysisHistory ?
            brandAnalysisHistory.map((historyItem) => (
              <>
                <div className="ComparisonHistory-box-container mb-3 py-4">
                  <div className="w-75 time">
                    <h3>
                      {historyItem.mainAnalysis.brandInformation.brandName}
                    </h3>
                    <p>

                    </p>
                  </div>
                  <div className="w-25 time">
                    <div className="ComparisonHistory-timeDetail-box">
                      <p>2:30 PM</p>
                      <button className="viewMoreBtn" onClick={() => {

                        setBrandAnalysis(historyItem)
                        setShowBrandAnalysis(true);
                      }}>Details</button>

                    </div>
                  </div>
                </div>

              </>
            ))
            :
            "No History Found!"
            :
            <GenerateReport ourBrand={brandAnalysis}></GenerateReport>
          } */}

          {/* <div className="ComparisonHistory-box-container mb-3 py-4">
            <div className="w-75 time">
              <h3>
                Daraz <span>VS</span> Amazon
              </h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a
                dictum nunc, quis ultrices orci. Cras cursus congue
                sollicitudin.
              </p>
            </div>
            <div className="w-25 time">
              <div className="ComparisonHistory-timeDetail-box">
                <p>2:30 PM</p>
                <button className="viewMoreBtn">Details</button>
              </div>
            </div>
          </div>
          <div className="ComparisonHistory-box-container mb-3 py-4">
            <div className="w-75 time">
              <h3>
                Southwest Airlines <span>VS</span> Delta Air Lines
              </h3>
              <p>
                Maecenas sit amet nisi vitae quam lacinia fermentum at quis
                eros. Aenean convallis ac felis bibendum tincidunt. Fusce semper
                est elementum ex blandit sagittis aenean et neque a nisi
                mollis.....
              </p>
            </div>
            <div className="w-25 time">
              <div className="ComparisonHistory-timeDetail-box">
                <p>1:30 PM</p>
                <button className="viewMoreBtn">Details</button>
              </div>
            </div>
          </div>
          <div className="ComparisonHistory-box-container mb-3 py-4">
            <div className="w-75 time">
              <h3>
                Alibaba <span>VS</span> Amazon
              </h3>
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi a
                dictum nunc, quis ultrices orci. Cras cursus congue
                sollicitudin.
              </p>
            </div>
            <div className="w-25 time">
              <div className="ComparisonHistory-timeDetail-box">
                <p>2:30 PM</p>
                <button className="viewMoreBtn">Details</button>
              </div>
            </div>
          </div>
          <div className="ComparisonHistory-box-container mb-3 py-4">
            <div className="w-75 time">
              <h3>
                Southwest Airlines <span>VS</span> Delta Air Lines
              </h3>
              <p>
                Maecenas sit amet nisi vitae quam lacinia fermentum at quis
                eros. Aenean convallis ac felis bibendum tincidunt. Fusce semper
                est elementum ex blandit sagittis aenean et neque a nisi
                mollis.....
              </p>
            </div>
            <div className="w-25 time">
              <div className="ComparisonHistory-timeDetail-box">
                <p>1:30 PM</p>
                <button className="viewMoreBtn">Details</button>
              </div>
            </div>
          </div>

          <div className="pagination-box">
            <ul class="pagination">
              <li>
                <a className="next" href="#" aria-label="Previous">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M15.975 22L17.75 20.225L9.525 12L17.75 3.775L15.975 2L5.975 12L15.975 22Z"
                      fill="#9C3B3C"
                    />
                  </svg>
                </a>
              </li>
              <li>
                <a href="#" className="active">
                  1
                </a>
              </li>
              <li>
                <a href="#">2</a>
              </li>
              <li>
                <a href="#">3</a>
              </li>
              <li>
                <a className="next" href="#" aria-label="Next">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M8.025 22L6.25 20.225L14.475 12L6.25 3.775L8.025 2L18.025 12L8.025 22Z"
                      fill="#9C3B3C"
                    />
                  </svg>
                </a>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default History;
